/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ConsoleInstanceConnectWorkspaceType*`'s.
 */
export type ConsoleInstanceConnectWorkspaceType =
  | ConsoleInstanceConnectWorkspaceTypeLimited
  | ConsoleInstanceConnectWorkspaceTypeFull;

/**
 * The dev type of the Connect workspace.
 * @export
 */
export type ConsoleInstanceConnectWorkspaceTypeLimited = typeof CONSOLE_INSTANCE_CONNECT_WORKSPACE_TYPE_LIMITED;

/**
 * The prod type of the Connect workspace.
 * @export
 */
export type ConsoleInstanceConnectWorkspaceTypeFull = typeof CONSOLE_INSTANCE_CONNECT_WORKSPACE_TYPE_FULL;

/**
 * The dev type of the Connect workspace.
 * @export
 */
export const CONSOLE_INSTANCE_CONNECT_WORKSPACE_TYPE_LIMITED = `limited`;

/**
 * The prod type of the Connect workspace.
 * @export
 */
export const CONSOLE_INSTANCE_CONNECT_WORKSPACE_TYPE_FULL = `full`;
